import { render, staticRenderFns } from "./AntibodyPopup.vue?vue&type=template&id=aaf0d0e2&scoped=true&"
import script from "./AntibodyPopup.vue?vue&type=script&lang=js&"
export * from "./AntibodyPopup.vue?vue&type=script&lang=js&"
import style0 from "./AntibodyPopup.vue?vue&type=style&index=0&id=aaf0d0e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf0d0e2",
  null
  
)

export default component.exports